import * as React from 'react';
import { CianContacts } from './components/CianContacts';
import * as styles from './AsideContacts.css';

export interface IAsideContactsProps extends React.PropsWithChildren {
  isLeadFactory?: boolean;
}

export const AsideContacts: React.FC<IAsideContactsProps> = ({ isLeadFactory, children }) => {
  if (isLeadFactory) {
    return <CianContacts>{children}</CianContacts>;
  }

  return <div className={styles['aside-contacts']}>{children}</div>;
};
